import keyMirror from '../helpers/keymirror';

const actionTypes = keyMirror({
  GET_TRADE_IDEAS: null,
});

export default actionTypes;
